module.exports = __webpack_public_path__ + "frontend/images/homepage/carousel/mobile/0@2.png?5f47d731c090becf54177a15e66760f5";